module.exports = __webpack_public_path__ + "img/base_activites_escalade.cf91d7aa.svg";